export default __webpack_public_path__ + "img/dd401d73b3e52fd82fc49bca92bca44f.png";